import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

const SHOP_BANNER = "https://images.pexels.com/photos/4901995/pexels-photo-4901995.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
const CATS = ["All", "Bags", "Apparel", "Gear"];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("All");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const filtered = cat === "All" ? products : products.filter((p) => p.category === cat);

  return (
    <div className="pt-16 min-h-screen">
      <section className="relative h-[42vh] min-h-[320px] flex items-end overflow-hidden">
        <img src={SHOP_BANNER} alt="Travellers" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pb-10 w-full">
          <span className="text-xs tracking-[0.25em] uppercase font-bold text-[#E8B291]">The Shop</span>
          <h1 className="font-display text-white text-4xl sm:text-6xl font-bold mt-2">Gear for the going.</h1>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10">
        <div className="flex gap-2 flex-wrap mb-8">
          {CATS.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors duration-200 ${
                cat === c ? "bg-[#2E523A] text-white" : "bg-white border border-[#D2D5CD] hover:border-[#2E523A]/40"
              }`}
              data-testid={`shop-category-${c.toLowerCase()}`}
            >
              {c}
            </button>
          ))}
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-testid="products-grid">
          {filtered.map((p, i) => (
            <ProductCard key={p.lookup_key} product={p} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
